import { selectActiveModules } from '../../../Containers/Events/selectors';
import { selectUI } from '../../../redux/ui/uiSelectors';
import { setSidebar } from '../../../redux/ui/actions';
import { useDispatch, useSelector } from 'react-redux';
import { useStyles } from '../styles';
import { useTheme } from '@material-ui/core/styles';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import CssBaseline from '@material-ui/core/CssBaseline';
import Divider from '@material-ui/core/Divider';
import Drawer from '@material-ui/core/Drawer';
import EFLogo from '../../../assets/eventfarm_logo.svg';
import IconButton from '@material-ui/core/IconButton';
import NestedList from './NestedList';
import React from 'react';
import clsx from 'clsx';
const Sidebar = () => {
    const theme = useTheme();
    const dispatch = useDispatch();
    const { active_event_id, sidebar, sidebarClicked } = useSelector(selectUI);
    const activeModules = useSelector(selectActiveModules);
    const classes = useStyles();
    const handleMouseOver = () => {
        //If sidebar is closed, let's open it
        if (!sidebarClicked) dispatch(setSidebar(true));
    };
    const handleMouseOut = () => {
        dispatch(setSidebar(false));
    };
    const handleCloseDrawer = () => {
        dispatch(setSidebar(false));
    };
    return (
        <React.Fragment>
            <CssBaseline />
            {sidebar && (
                <Drawer
                    className={clsx(classes.drawer, {
                        [classes.drawerOpen]: sidebar,
                        [classes.drawerClose]: !sidebar,
                    })}
                    classes={{
                        paper: clsx({
                            [classes.drawerOpen]: sidebar,
                            [classes.drawerClose]: !sidebar,
                        }),
                    }}
                    data-cy="Sidebar"
                    data-cy-open={sidebar}
                    onMouseEnter={handleMouseOver}
                    onMouseLeave={handleMouseOut}
                    open={sidebar}
                    variant="permanent"
                >
                    <div className={classes.drawerToolbar}>
                            <img alt="Logo" className={classes.logo} src={EFLogo} />

                        <IconButton data-cy="SidebarClose" onClick={handleCloseDrawer}>
                            {theme.direction === 'rtl' ? <ChevronRightIcon /> : <ChevronLeftIcon />}
                        </IconButton>
                    </div>
                    <Divider />
                    <NestedList active_event_id={active_event_id} activeModules={activeModules} sidebar={sidebar} />
                    <Divider />
                </Drawer>
            )}
        </React.Fragment>
    );
};

export default Sidebar;
